export const PasswordRecoveryModal: string = 'PasswordRecoveryModal';
